import {ReactNode} from 'react';

import {ProductGroup} from 'core/constants/productGroups';

import {AuthenticStatus} from 'core/dictionaries';

import {PackageTypes} from './gtins';

export interface ProductsGridRawRow {
    gtin: string | null;
    productName: string;
    markingCode: string;
    status: string;
    modifiedAt: string;
    packagingType: PackageTypes;
    manufacturerName: string;
    productGroupCode: ProductGroup;
    owner: string | null;
    authenticStatus?: AuthenticStatus | null;
    parentMarkingCode?: string | null;
    parentGtin: string | null;
    orderId?: string | null;
    storageLocationAddress?: string | null;
    storageLocationName?: string | null;
    ownerTin?: string | null;
}

export enum ProductsGridAccessors {
    gtin = 'gtin',
    name = 'productName',
    code = 'markingCode',
    nesting = 'nesting',
    status = 'status',
    modifiedAt = 'modifiedAt',
    packageType = 'packagingType',
    manufacturer = 'manufacturerName',
    codesFilter = 'codesFilter',
    codesFileFilter = 'codesFileFilter',
    productGroupCode = 'productGroupCode',
    owner = 'owner',
    parentMarkingCode = 'parentMarkingCode',
    parentGtin = 'parentGtin',
    authenticStatus = 'authenticStatus',
    orderId = 'orderId',
    storageLocationAddress = 'storageLocationAddress',
    storageLocationName = 'storageLocationName',
    ownerTin = 'ownerTin',
    ownerTinOrName = 'ownerTinOrName',
}

export interface ProductsGridFormattedRow {
    [ProductsGridAccessors.name]: string;
    [ProductsGridAccessors.code]: string;
    [ProductsGridAccessors.status]: string;
    [ProductsGridAccessors.modifiedAt]: string;
    [ProductsGridAccessors.packageType]: string;
    [ProductsGridAccessors.manufacturer]: string;
    [ProductsGridAccessors.productGroupCode]?: ReactNode;
    [ProductsGridAccessors.storageLocationAddress]?: string;
    [ProductsGridAccessors.storageLocationName]?: string;
    [ProductsGridAccessors.authenticStatus]: ReactNode | string;
    [ProductsGridAccessors.gtin]?: string;
}
